import React from 'react';

const DataDeletion = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8">
        <h1 className="text-4xl font-bold text-amber-900 mb-6">Data Deletion Request</h1>
        <p className="text-gray-600 mb-8">Magic Moments - User Data Deletion Instructions</p>
        
        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold text-amber-800 mb-3">How to Delete Your Account and Data</h2>
            <p className="mb-4">
              We respect your privacy and your right to control your personal data. If you would like to 
              delete your Magic Moments account and all associated data, please follow the instructions below.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-amber-800 mb-3">What Gets Deleted</h2>
            <p className="mb-3">When you request account deletion, we will permanently remove:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Your account information (name, email, profile picture)</li>
              <li>All photos and videos you uploaded</li>
              <li>All AI-generated animated moments</li>
              <li>Your albums and collections</li>
              <li>Purchase history and transaction records</li>
              <li>All other personal data associated with your account</li>
            </ul>
            <p className="mt-4 text-amber-700 font-medium">
              ⚠️ This action is permanent and cannot be undone.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-amber-800 mb-3">How to Request Deletion</h2>
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 mb-4">
              <p className="mb-3 font-medium">To delete your Magic Moments account and data:</p>
              <ol className="list-decimal list-inside space-y-3 ml-4">
                <li>
                  <strong>Email us at:</strong>
                  <a 
                    href="mailto:support@magic-moments.ai?subject=Data Deletion Request"
                    className="text-amber-600 hover:text-amber-700 font-semibold ml-2"
                  >
                    support@magic-moments.ai
                  </a>
                </li>
                <li>
                  <strong>Subject line:</strong> Data Deletion Request
                </li>
                <li>
                  <strong>Include in your email:</strong>
                  <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                    <li>The email address associated with your account</li>
                    <li>Your account name (if different from email)</li>
                    <li>Confirmation that you want to permanently delete all your data</li>
                  </ul>
                </li>
              </ol>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-amber-800 mb-3">Processing Timeline</h2>
            <p>
              We will process your data deletion request within <strong>30 days</strong> of receiving 
              your email. You will receive a confirmation email once the deletion is complete.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-amber-800 mb-3">Data We May Retain</h2>
            <p className="mb-3">
              For legal and security purposes, we may retain certain information even after account deletion:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Transaction records required for financial compliance (7 years)</li>
              <li>Data needed to comply with legal obligations</li>
              <li>Information necessary to resolve disputes or enforce our agreements</li>
            </ul>
            <p className="mt-4 text-sm text-gray-600">
              This retained data is minimal and is kept only as long as legally required.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-amber-800 mb-3">Questions?</h2>
            <p>
              If you have any questions about the data deletion process or our data practices, 
              please contact us at:
            </p>
            <p className="mt-3">
              <strong>Email:</strong>
              <a 
                href="mailto:support@magic-moments.ai"
                className="text-amber-600 hover:text-amber-700 font-medium ml-2"
              >
                support@magic-moments.ai
              </a>
            </p>
          </section>

          <section className="bg-gray-50 border border-gray-200 rounded-lg p-6 mt-8">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Alternative: Delete Account In-App
            </h3>
            <p className="text-gray-600">
              You can also delete your account directly from within the app:
            </p>
            <ol className="list-decimal list-inside space-y-1 ml-4 mt-2 text-gray-600">
              <li>Log in to your Magic Moments account</li>
              <li>Go to Settings → Account Settings</li>
              <li>Click "Delete Account"</li>
              <li>Confirm deletion</li>
            </ol>
          </section>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-200 flex justify-between items-center">
          <a 
            href="/"
            className="text-amber-600 hover:text-amber-700 font-medium"
          >
            ← Back to Magic Moments
          </a>
          <a 
            href="/privacy-policy"
            className="text-gray-600 hover:text-gray-700 font-medium"
          >
            Privacy Policy →
          </a>
        </div>
      </div>
    </div>
  );
};

export default DataDeletion;
